import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from '../ui/Button';
export const HeroSection = () => {
  return <section className="pt-12 pb-16 px-4 md:px-8 max-w-4xl mx-auto text-center" data-id="element-159">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} data-id="element-160">
        <p className="text-orange-500 font-bold text-sm md:text-base uppercase tracking-widest mb-4" data-id="element-161">
          🇦🇷 El sistema N°1 de cocina para familias argentinas
        </p>
        <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 leading-tight" data-id="element-162">
          🍽️ COCINA <span className="text-orange-500" data-id="element-163">RESUELTA™</span>
        </h1>
        <h2 className="text-2xl md:text-3xl font-bold text-gray-200 mb-10" data-id="element-164">
          Terminá con el "¿qué comemos hoy?"
        </h2>

        <div className="relative w-full max-w-2xl mx-auto mb-10" data-id="element-165">
          <div className="absolute inset-0 bg-orange-500 blur-[100px] opacity-20 rounded-full" data-id="element-166"></div>
          <img src="https://cdn.magicpatterns.com/uploads/xhwesft3rsWQqdfXWJNQxD/bb65bef8-0490-44a3-845a-edb5cd0ba8b0.png" alt="Cocina Resuelta Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-167" />
        </div>

        <p className="text-xl md:text-2xl text-gray-300 font-medium mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-168">
          5 Tomos + 5 Bonos — 90 recetas listas. Sin estrés. Sin repetir lo
          mismo.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-169">
          {['100% PDF', 'Acceso en 5 min', '90+ recetas', '5 tomos + 5 bonos'].map((pill, i) => <div key={i} className="flex items-center gap-2 bg-gray-900 border border-orange-500/30 rounded-full px-4 py-2" data-id="element-170">
              <Check className="w-5 h-5 text-orange-500" data-id="element-171" />
              <span className="text-white font-bold text-sm md:text-base" data-id="element-172">
                {pill}
              </span>
            </div>)}
        </div>

        <div className="max-w-xl mx-auto" data-id="element-173">
          <Button href="#comprar" data-id="element-174">👉 QUIERO MI COCINA RESUELTA AHORA</Button>
          <p className="mt-4 text-gray-400 text-sm font-medium flex items-center justify-center gap-2" data-id="element-175">
            <span className="text-orange-500" data-id="element-176">✓</span> Garantía 7 días ·
            <span className="text-orange-500" data-id="element-177">✓</span> Pago seguro ·
            <span className="text-orange-500" data-id="element-178">✓</span> Mercado Pago
          </p>
        </div>
      </motion.div>
    </section>;
};